import React, { useState, useEffect, useRef } from 'react';

import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

let count = 0;
let sliderInterval;

const Slider = ({ imageList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef();

  const handleNextClick = () => {
    count = (count + 1) % imageList.length;
    sliderRef.current.classList.add('animate-fade');
    setCurrentIndex(count);
  }

  const handlePrevClick = () => {
    const imageListCount = imageList.length;
    count = (currentIndex + imageListCount - 1) % imageListCount;
    sliderRef.current.classList.add('animate-fade');
    setCurrentIndex(count);
  }

  const playSlider = () => {
    sliderInterval = setInterval(() => {
      handleNextClick();
    }, 5000);
  }

  const pauseSlider = () => {
    clearInterval(sliderInterval);
  }

  const removeAnimation = () => {
    sliderRef.current.classList.remove('animate-fade');
  }

  useEffect(() => {
    playSlider();
    sliderRef.current.addEventListener('animationend', removeAnimation);
    sliderRef.current.addEventListener('mouseenter', pauseSlider);
    sliderRef.current.addEventListener('mouseleave', playSlider);

    return () => {
      clearInterval(sliderInterval);
    }
  }, []);

  return (
    <div ref={sliderRef} className="w-full relative select-none">
      <img className="w-full h-64 md:h-screen object-cover" src={imageList[currentIndex]} alt="Hero" />
      <div className="absolute w-full top-1/2 bottom-1/2 flex justify-between items-center px-5">
        <button
          className="p-2 rounded-full transition-opacity duration-200 bg-white relative z-10 md:opacity-50 md:hover:opacity-100"
          onClick={handlePrevClick}
        >
          <FiChevronLeft size={20} className="text-slate-500" />
        </button>
        <button
          className="p-2 rounded-full transition-opacity duration-200 bg-white relative z-10 md:opacity-50 md:hover:opacity-100"
          onClick={handleNextClick}
        >
          <FiChevronRight size={20} className="text-slate-500" />
        </button>
      </div>
    </div>
  );
};

export default Slider;
